import { render, staticRenderFns } from "./improveInfor.vue?vue&type=template&id=02c4e0db&scoped=true"
import script from "./improveInfor.vue?vue&type=script&lang=js"
export * from "./improveInfor.vue?vue&type=script&lang=js"
import style0 from "./improveInfor.vue?vue&type=style&index=0&id=02c4e0db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c4e0db",
  null
  
)

export default component.exports